import styled from 'styled-components';
import { crTheme } from '@comicrelief/component-library';

const BraintreeFieldsElement = styled.div`
  padding: 1rem 1.5rem;
  height: 3.3rem;
  border-radius: 0.5rem;
  border: ${crTheme.color('grey')} 1px solid;
`;

const RecaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export {
  BraintreeFieldsElement,
  RecaptchaWrapper
};
